
export default class FormItemTimeResolver
{
	static TIMEFORMATSTRING = "hh:mm:ss";
	
	//判断字符串是否由数字组成且符合时间格式
	static IsNum(dateInput)
	{
		var patternNum =/^-?\d+$/;
		var patternTime = /^(\d{1,2})(:)?(\d{1,2})\2(\d{1,2})$/;
		var result = patternNum.exec(dateInput);
		if(result == null)
		{
			if(patternTime.exec(dateInput) == null)
			{
				return false;
			}
		}
		return true;
	}
	
	//		输入字符串的长度为0
	static convertToDateLenIsNull()
	{
		var date=new Date();
		return FormItemTimeResolver.dataStyle(date);
	}
	
	//如果用户输入字符串长度为1&2
	static convertToDateLenIs1(dateInput)
	{
		var today=new Date();
		var date=parseInt(dateInput);
		
		
		if(date<=23 && date>=0)
		{
			today.setHours(date);
			today.setSeconds(0);
			today.setMinutes(0);
		}
		else
		{
			today.setHours(0);
			today.setMinutes(0);
			today.setSeconds(0);
		}
		
		return FormItemTimeResolver.dataStyle(today);
	}
	//		输入字符串的长度为3&4
	static convertToDateLenIs4(dateInput)
	{
		var _date=new Date();
		var hour;
		var day;
		if(dateInput.length==3)
			dateInput = "0" + dateInput;
		
		
		hour=parseInt(dateInput.charAt(0)+dateInput.charAt(1));
		day=parseInt(dateInput.charAt(2)+dateInput.charAt(3));
		
		if(hour<=23 && hour>=0)
		{
			_date.setHours(hour);
		}
		else
		{
			_date.setHours(0);
		}
		if(day>=0&& day<59)
		{
			_date.setMinutes(day);
		}
		else
		{
			_date.setMinutes(59);
		}
		
		_date.setSeconds(0);
		
		return FormItemTimeResolver.dataStyle(_date);
	}
	
	//若果用户输入5&6个字符
	static convertToDateLenIs6(dateInput)
	{
		var dateOutput=new Date();
		var hour;
		var min;
		var seconds;
		
		if(dateInput.length==5)
			dateInput = "0" + dateInput;
		
		hour=parseInt(dateInput.charAt(0)+dateInput.charAt(1)); //hours
		min=parseInt(dateInput.charAt(2)+dateInput.charAt(3)); //minutes
		seconds=parseInt(dateInput.charAt(4)+dateInput.charAt(5)); //seconds
		
		if(hour<=23 && hour>=0)
		{
			dateOutput.setHours(hour);
		}
		else
		{
			dateOutput.setHours(0);
		}
		if(min>=0&& min<=59)
		{
			dateOutput.setMinutes(min);
		}
		else
		{
			dateOutput.setMinutes(59);
		}
		if(seconds>=0 && seconds<=59)
		{
			dateOutput.setSeconds(seconds);
		}
		else
		{
			dateOutput.setSeconds(59);
		}
		
		return FormItemTimeResolver.dataStyle(dateOutput);
		
	}
	
	
	//日期以HHNNSS输出
	static dataStyle(date)
	{
		return date.format(FormItemTimeResolver.TIMEFORMATSTRING);
	}
	
	
	static getFormattedTime(_time)
	{
		var array = _time.split(":");
		var hour = array[0];
		var min = array[1];
		var second = array[2];
		
		if(hour.length == 1)
			hour = "0"+ hour;
		
		if(min.length == 1)
			min = "0"+ min;
		
		if(second.length == 1)
			second = "0"+ second;
		
		return hour + min + second ;
	}
	
	//对用户输入的时间进行验证
	static getResult()
	{
		var timeInput = arguments[0];
		if(timeInput.indexOf('.') != -1){
			timeInput = timeInput.substr(0,timeInput.indexOf('.')).trim();
		}
		var notnull = arguments[1];
		if(timeInput == "")
		{
			if(notnull)
				return "false:不允许为空";
			else
				return timeInput;
		}
			
		if(timeInput == "t")
		{
			return FormItemTimeResolver.dataStyle(new Date());
		}
		
		var length = timeInput.length;
		
		if(FormItemTimeResolver.IsNum(timeInput))
		{
			if(timeInput.indexOf(":") != -1)
			{	
				return FormItemTimeResolver.convertToDateLenIs6(FormItemTimeResolver.getFormattedTime(timeInput));
			}
			else
			{
				if(length > 6)
					return "false:长度不能超过8位";
			}
			
			switch(length)
			{
				case 1:
				{
					return FormItemTimeResolver.convertToDateLenIs1(timeInput);
					break;
				}
				case 2:
				{
					return FormItemTimeResolver.convertToDateLenIs1(timeInput);
					break;
				}
				case 3:
				{
					return FormItemTimeResolver.convertToDateLenIs4(timeInput);
					break;
				}
				case 4:
				{
					return FormItemTimeResolver.convertToDateLenIs4(timeInput);
					break;
				}
				case 5:
				{
					return FormItemTimeResolver.convertToDateLenIs6(timeInput);
					break;
				}
				case 6:
				{
					return FormItemTimeResolver.convertToDateLenIs6(timeInput);
					break;
				}
				default:
				{	return FormItemTimeResolver.convertToDateLenIsNull();
					break;
				}
			}
		}
		/*else
		{
			if(timeInput=="")
				return "00:00:00";
		}
		return "false:not valid!";*/
		return "false:格式有误";
	}

}



// WEBPACK FOOTER //
// ./src/formItem/resolver/FormItemTimeResolver.js